module.exports = __webpack_public_path__ + "static/media/menu.d204b48a.svg";